import serialize from "json-form-data";
import axios from "axios";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';
import { userPermissionsList } from "../../../constants/userPermissions";

const api_url = "/index.php";

const reformatDate = (date) => {
    const [day, month, year] = date.split(".");
    return `${year}-${month}-${day}`;
};

const formatAnalyse = (data) =>
    serialize({
        analysis_id: data.analyseId,
        worker_id: data.workerId,
        date: reformatDate(data.analyseDate),
        comment: data.analyseComment,
        fileIds: data.fileIds,
    });

const actions = {
    async getLinkForArchiveOfAnalyses({ rootState }, workerId) {
        const token = rootState.authToken;
        const url = addAuthKey(`${api_url}/?r=api/worker-medical-analysis/archive&workerId=${workerId}`, token);
        const { data } = await axios.get(url);
        return data;
    },
    async getLinkForArchiveOfAnalyse({ rootState }, { workerId, analyseId }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${api_url}/?r=api/worker-medical-analysis/archive&workerId=${workerId}&analysisId=${analyseId}`, token);
        const { data } = await axios.get(url);
        return data;
    },
    async fetchRequiredAnalysesList({ rootState }, workerId) {
        const token = rootState.authToken;
        const url = addAuthKey(`${api_url}/?r=api/worker-medical-analysis/required&workerId=${workerId}`, token);
        const { data } = await axios.get(url);
        return data;
    },
    async fetchAddedAnalysesList({ rootState }, { workerId, sort }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${api_url}/?r=api/worker-medical-analysis/index&workerId=${workerId}&sort=${sort}`, token);
        const { data } = await axios.get(url);
        return data;
    },
    async addAnalyseToWorker({ dispatch, rootState }, analyseData) {
        const token = rootState.authToken;
        const { workerId } = analyseData;

        const uploadFiles = async (files) => {
            const ids = [];
            for (let i = 0; i < files.length; i++) {
                ids.push(dispatch("uploadFile", { workerId, file: files[i] }));
            }
            return Promise.all(ids).then(res => res.map(item => item.id));
        };

        const uploadedFilesIds = await uploadFiles(analyseData.files);

        const formData = formatAnalyse({ ...analyseData, fileIds: uploadedFilesIds });

        const url = addAuthKey(`${api_url}/?r=api/worker-medical-analysis/create&workerId=${analyseData.workerId}`, token);
        const { data } = await axios.post(url, formData);
        
        return data;
    },
    async uploadFile({ rootState }, { workerId, file }) {
        const token = rootState.authToken;
        const formData = new FormData();

        formData.append("file", file);

        const url = addAuthKey(`${api_url}/?r=api/worker-medical-analysis/upload-file&workerId=${workerId}`, token);
        const { data } = await axios.post(url, formData);
        
        return data;
    },
    async deleteAnalyse({ rootState }, analyseId) {
        const token = rootState.authToken;
        const url = addAuthKey(`${api_url}/?r=api/worker-medical-analysis/delete&id=${analyseId}`, token);

        const { data } = await axios.delete(url);

        return data;
    },
};

const getters = {
    isUserAbleToControlAnalyses(state, getters, rootState, rootGetters) {
        return rootGetters.getUserPermissions.includes(userPermissionsList.worker.medicalAnalyses.control);
    },
};

export default {
    namespaced: true,
    actions,
    getters,
};
